import { jsx as _jsx } from "react/jsx-runtime";
import ColorContrastChecker from 'color-contrast-checker';
import { Badge } from '@tribeplatform/react-ui-kit/Badge';
import { getFieldSetting } from '../utils';
export const PillsView = ({ value, field }) => {
    if (!(value === null || value === void 0 ? void 0 : value.length)) {
        return null;
    }
    if (typeof value === 'string') {
        value = [value];
    }
    const contrastChecker = new ColorContrastChecker();
    return (_jsx("div", { className: "flex flex-wrap space-s-2", children: value === null || value === void 0 ? void 0 : value.map(text => {
            let textColor;
            const selectOptions = getFieldSetting(field, 'selectOptions');
            const currentOption = selectOptions === null || selectOptions === void 0 ? void 0 : selectOptions.find(option => (option === null || option === void 0 ? void 0 : option.value) === text);
            const color = currentOption === null || currentOption === void 0 ? void 0 : currentOption.color;
            if (color) {
                textColor =
                    contrastChecker.hexToLuminance(color) < 0.5 ? '#ffffff' : '#000000';
            }
            return (_jsx(Badge, { size: "lg", variant: "secondary", style: { backgroundColor: color, color: textColor }, children: text }, text));
        }) }, void 0));
};
//# sourceMappingURL=PillsView.js.map